
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/kakao",
      function () {
        return require("private-next-pages/landing/kakao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/kakao"])
      });
    }
  